import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from '@core/services';


@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
})
export class BillingComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  tab: string | null = null;
  showPayPerUse: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.showPayPerUse = this.featureFlagService.getFeatureFlag('enable_ppu') === true;
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const activeTab = params.get('activeTab');
      if (activeTab === 'parking' || activeTab === 'invoices') {
        this.tab = activeTab;
      } else {
        this.tab = null;
      }
    });
  }
}
